import {lazyWithRetry} from '../lazyWithRetry/lazyWithRetry';

export const LazyBillingDetails = lazyWithRetry(() => import('./billingDetails'));
